var $$config = require('../config.js');
var $$request = require('assets/lib-request.js');

module.exports = {
    get: function(url, data, fn) {
        $$request.ajax({
            url: $$config.mock? '/mock' + url: url,
            data: data,
            type: 'GET',
            dataType: 'application/json',
            withCredentials: true,
            complete: function (data) {
                var newData = {};
                newData.code = data.code;
                newData.msg = data.msg;
                newData.data = data.data;
                if (typeof fn === 'function') {
                    fn(newData);
                }
            }
        });
    },

    post: function(url, data, fn) {
        $$request.ajax({
            url: $$config.mock? '/mock' + url: url,
            data: data,
            type: 'POST',
            dataType: 'application/json',
            withCredentials: true,
            complete: function (data) {
                var newData = {};
                newData.code = data.code;
                newData.msg = data.msg;
                newData.data = data.data;
                if (typeof fn === 'function') {
                    fn(newData);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/model/ajax.js